import { createSlice } from '@reduxjs/toolkit';
import { resetStore } from '../../Actions';

const initialState = {
  loader: { loading: false, loadingMessage: null }
};

const LoaderSlice = createSlice({
  name: 'Loader',
  initialState,
  reducers: {
    setIsLoading(state, action) {
      state.loader.loading = action.payload.loading;
      state.loader.loadingMessage = action.payload.loadingMessage || null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

export const { setIsLoading } = LoaderSlice.actions;
export default LoaderSlice.reducer;
